import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';
import logo from '../Assets/images/logo.jpg';

const OurServices = () => {
  const services = [
    {
      title: 'Airport Transfer',
      description:
        'As a global premium chauffeur service, we deliver airport transfers that combine precision, luxury, and peace of mind.',
      image: require('../Assets/images/airport.jpg'),
    },
    {
      title: 'Chauffeur Service',
      description:
        'Experience the highest level of comfort and class with our premium chauffeur service.',
      image: require('../Assets/images/chauffeur.jpg'),
    },
    {
      title: 'City to City Rides',
      description:
        'A new level of intercity travel with chauffeur rides—comfort, privacy, and punctuality.',
      image: require('../Assets/images/city.webp'),
    },
    {
      title: 'Car Rental',
      description:
        'We offer premium car rentals with or without a chauffeur—perfect for business or leisure.',
      image: require('../Assets/images/car.jpg'),
    },
    {
      title: 'Meet & Greet Service',
      description:
        'At major airports worldwide, our Meet & Greet service ensures timely assistance and smooth start or end.',
      image: require('../Assets/images/greet.jpg'),
    },
   
  ];

  return (
    <div className="our-services-page">
      
      <header className="navbar">
        <div className="top-bar">
          <span>📍 Juffair - Bahrain</span>
          <span>📧 support@limoxyworld.com</span>
          <span>⏰ 24/7 Available</span>
        </div>
        <div className="main-nav">
          <div className="logo-container">
            <img src={logo} alt="Limoxy Logo" className="logo-image" />
            <span className="logo-text">LIMOXY</span>
          </div>
          <nav>
            <a href="/">Home</a>
            <a href="/about">About Us</a>
            <a href="/services">Our Services</a>
            <a href="/contact">Contact</a>
            <a href="/partner">Partner</a>
          </nav>
          <Link to="/Bookride">
                        <button className="book-btn">Book Your Ride</button>
                    </Link>
        </div>
      </header>

   
      <section className="services-main">
        <h1>Our Services</h1>
        <p className="services-subtext">Explore our tailored luxury transportation services</p>
        <div className="service-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <img src={service.image} alt={service.title} />
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo} alt="Limoxy Logo" className="footer-logo-img" />
            <h3>Limoxy World</h3>
          </div>
          <p>World-class chauffeur service in 45,000+ locations. Luxury. Precision. Trust.</p>
          <div className="footer-links">
            <a href="/">Home</a>
            <a href="/about">About</a>
            <a href="/services">Services</a>
            <a href="/contact">Contact</a>
            <a href="/partner">Partner</a>
          </div>
          <p className="footer-bottom">© {new Date().getFullYear()} Limoxy World. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default OurServices;